export enum QueryType {
  Generic = 'GENERIC',
  KPI = 'KPI',
  Compare = 'COMPARE',
  Test = 'TEST',
}
